<wbo-edit-grid [data]="model.data[fieldName]" [editable]="true" [removable]="true" [entityPath]="fieldName" [title]="'wbo.report.price-level-selection.title'">
    <wbo-edit-grid-message>
        <fui-inline-information [title]="'wbo.common.info.information'"
                                [message]="'wbo.report.price-level-selection.message.maxLength'"></fui-inline-information>
    </wbo-edit-grid-message>
    <wbo-text-column field="name" [title]="'wbo.report.price-level-selection.column.name'"></wbo-text-column>
    <wbo-edit-grid-add-row [identifierField]="'priceLevelId'">
        <wbo-edit-grid-add-row-quick-add>
            <wbo-price-level-single-select-edit-control></wbo-price-level-single-select-edit-control>
        </wbo-edit-grid-add-row-quick-add>
        <wbo-edit-grid-add-row-actions>
            <wbo-edit-grid-add-row-search [searchComponent]="PriceLevelSearchPageComponent"></wbo-edit-grid-add-row-search>
        </wbo-edit-grid-add-row-actions>
    </wbo-edit-grid-add-row>
</wbo-edit-grid>
